import { NotificationManager } from 'react-notifications';
import { IsJsonString } from './validationHelpers';

const handleException = (error, fallback_msg = 'Something went wrong', use_fallback_msg_as_default = false, cancel_support = null) => {
    if (cancel_support) {
        return;
    }
    const error_msg = getErrorMessage(error, fallback_msg);
    NotificationManager.error((use_fallback_msg_as_default ? fallback_msg : error_msg));
}

const getErrorMessage = (error, fallback_msg) => {
    if(!error.response){
        if(navigator.onLine) {
            return 'Something went wrong';
        }
        else{
            return 'Oops! Looks like your internet is down.'
        }
    }
    if (error.response) {
        if (error.response.data) {
            if (error.response.data.message) {
                return error.response.data.message;
            }
            if (error?.response?.data?.data?.message) {
                return error?.response?.data?.data?.message;
            }
            if (typeof error.response.data === 'string') {
                return error.response.data;
            }
            if (typeof error.response === 'string') {
                return error.response
            }
            let error_type = String.fromCharCode.apply(null, new Uint8Array(error.response.data));
            if(error_type && IsJsonString(error_type)){
                if(JSON.parse(error_type).message){
                    return JSON.parse(error_type).message
                }
                else if( typeof error_type === 'string' && error_type.length && error.response.status === 500){
                    return error_type;
                }
            }
        }
    }
    if(error.response){
        switch (error.response.status) {
            case 429:
                return 'Too many login attempts';
            case 401:
                return 'Session Expired';
            case 500:
                return (error.response.data.error ? error.response.data.error : fallback_msg)
            default:
                return (fallback_msg.length ? fallback_msg : 'Something went wrong');
        }
    }
    return fallback_msg;
}

export default handleException;